import Http from "@/Http/Request";
import { LoginPayload, LoginResponse } from "./types";
import { useMutation } from "react-query";

const login = async (payload: LoginPayload) => {
	
	const { data } = await Http({
		method: 'POST',
		url: 'loginUserApi',
		data: payload
	});
	return data;
};


const useLogin = () => {


	const mutation = useMutation<LoginResponse, Error, LoginPayload>({
		mutationKey: ['login'],
		mutationFn: (payload: LoginPayload) => login({
			account: payload.account,
			password: payload.password
		})

	})


  return mutation

}

export default useLogin